import { useLanguageContext } from "@/hooks";
import type { DashboardAction, DashboardKpiConfig, DashboardProfile } from "./types";

interface Props {
  profile: DashboardProfile;
  kpis: DashboardKpiConfig[];
  hasPrimaryContent?: boolean;
  className?: string;
  executeAction: (action: DashboardAction) => void;
}

const ProfileCardKpis = ({ profile, kpis, className, executeAction }: Props) => {
  const { language } = useLanguageContext();
  if (kpis.length === 0) return null;

  return (
    <div className={className ?? "col-lg-6 col-xl-5"}>
      <div className="d-flex gap-3 align-items-center h-100">
        {kpis.map((kpi) => (
          <div className="d-flex flex-column justify-content-center bg-white rounded-4 p-3 text-center h-100 flex-fill w-50 shadow-sm border" key={kpi.id}>
            <h2 className="fw-bolder">{profile.metrics[kpi.valueKey] ?? 0}</h2>
            <div role={kpi.action ? "button" : undefined} className="fs-7 d-flex align-items-center justify-content-center text-nowrap mt-2" onClick={() => kpi.action && executeAction(kpi.action)}>
              <span className="fw-semibold me-2">{language(kpi.labelKey) || kpi.labelKey}</span>
              {kpi.action && (
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle kg-danger kg-bg-warning-light" style={{ width: 15, height: 15 }}>
                  <i className="bi bi-chevron-right fs-10" />
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileCardKpis;
